import { oneTimeAddressFormStyles } from "@insite/content-library/Widgets/CheckoutShipping/ShippingAddressForm";
import { css } from "styled-components";

/**** EC-564-[FE] Code injection ****

*** Start: Refactored dynamic CSS from CMS to code for consistent behavior across environments. */
oneTimeAddressFormStyles.formFields = {
    container: {
        css: css`
            label {
                font-size: 15px;
                font-weight: 600;
            }
        `,
    },
};

/* *** End: Dynamic CSS refactoring complete. Apply future updates here instead of the CMS.*/
